import React, { useEffect, useState } from "react";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import { MaterialReactTable } from "material-react-table";
import { Edit } from "@mui/icons-material"; // Importing Material UI icons
import {
  FaFileExcel,
  FaMailBulk,
  FaWhatsapp,
} from "react-icons/fa";
import SubmitButton from "components/SubmitButton/SubmitButton";
import userResources from "api/userResources";
import UserInfoModal from "components/UserInfoModal/UserInfoModal";
import { avtar } from "utils/images";
import ConfirmModal from "components/ConfirmModal/ConfirmModal";
import DateFilter from "components/DateFilter/DateFilter";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../redux/userSlice";
import { toast } from "react-toastify";
import Modal from "components/daisyUiMsgModal/Modal";
import CustomerInfoModal from "components/CustomerInfoModal/CustomerInfoModal";
import AirticketInvoiceModal from "components/InvoiceModal/AirticketInvoiceModal";
import InvoiceModal from "components/InvoiceModal/InvoiceModal";
import MiscInvoiceModal from "components/InvoiceModal/MiscInvoiceModal";
import generateExcelFile from "./ExcelSheetFunction/InvoiceMainExcelSheet";
export default function InvoiceList({ searchComponentParams }) {
  const userInfo = useSelector(selectUserInfo);
  const location = useLocation();
  const navigate = useNavigate();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [invocieData, setInvoiceData] = useState();
  const [customerModalData, setCustomerModalData] = useState({});
  const [itinerary, setItinerary] = useState(""); // State for modal
  const [isInsourenceModalOpen, setIsInsourenceModalOpen] = useState(false);
  const [insourenceData, setInsourenceData] = useState();
  const [isLandPackageModalOpen, setIsLandPackageModalOpen] = useState(false);
  const [landPackageData, setLandPackageData] = useState();
  const [isMiscModalOpen, setIsMiscModalOpen] = useState(false);
  const [miscData, setMiscData] = useState();
  const [isCruiseModalOpen, setIsCruiseModalOpen] = useState(false);
  const [cruiseData, setCruiseData] = useState();
  const [isHotelModalOpen, setIsHotelModalOpen] = useState(false);
  const [hotelData, setHotelData] = useState();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
 

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = (assignedUser) => {
    setUserProfile(assignedUser);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setUserProfile({}); // Reset user profile on close
  };

  const filter = {
    invoice_number: globalFilter,
    start_date: startDate,
    end_date: endDate,
  };

  const getInvoiceList = async (
    pageIndex = 0, // Default to 0 if not provided
    pageSize = 10, // Default to 10 if not provided
    globalFilter = "",
    filterValues = {}
  ) => {
    setIsLoading(true); // Start loading state
    setIsError(false); // Reset error state

    try {
      const params = {
        page: pageIndex + 1, // Convert to 1-based index for API
        limit: pageSize,
        invoice_number: globalFilter, // Filter by invoice_number or global search
        ...filterValues, // Additional filters
        ...searchComponentParams,
      };

      // Filter out keys with empty or undefined values
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(
          ([key, value]) =>
            value !== undefined && value !== null && value !== ""
        )
      );

      const response = await userResources.totalInvoice(filteredParams);
      window.scrollTo(0, 0);

      // Update state with API response
      setTotalRows(response?.data?.paginate_data?.total || 0); // Total rows for pagination
      setData(response?.data?.data || []); // Main data array
    } catch (error) {
      console.error("Error fetching invoice list:", error);
      setIsError(true); // Set error state
      setData([]); // Clear data on error
    } finally {
      setIsLoading(false); // End loading state
    }
  };

  const handleModalOpen = (data) => {
    setItinerary(data); // Set the travel experience text
    setIsInfoModalOpen(true); // Open the modal
  };
  const handleModalClose = () => {
    setIsInfoModalOpen(false); // Close the modal
    setItinerary(""); // Reset the travel experience
  };

  const handleCustomerModalOpen = (data) => {
    setCustomerModalData(data); // Set the travel experience text
    setIsCustomerModalOpen(true); // Open the modal
  };
  const handleCustomerModalClose = () => {
    setIsCustomerModalOpen(false); // Close the modal
    setCustomerModalData(""); // Reset the travel experience
  };

  const handleInvocieModalOpen = (data) => {
    setInvoiceData(data); // Set the travel experience text
    setIsInvoiceModalOpen(true); // Open the modal
  };
  const handleInvoiceModalClose = () => {
    setIsInvoiceModalOpen(false); // Close the modal
    setInvoiceData(""); // Reset the travel experience
  };

  const handleInsouranceModalClose = () => {
    setIsInsourenceModalOpen(false); // Close the modal
    setInsourenceData(""); // Reset the travel experience
  };

  const handleHotelModalClose = () => {
    setIsHotelModalOpen(false); // Close the modal
    setHotelData(""); // Reset the travel experience
  };

  const handleLandPackageModalClose = () => {
    setIsLandPackageModalOpen(false); // Close the modal
    setLandPackageData(""); // Reset the travel experience
  };

  const handleCruiseModalClose = () => {
    setIsCruiseModalOpen(false); // Close the modal
    setCruiseData(""); // Reset the travel experience
  };

  const handleMiscModalClose = () => {
    setIsMiscModalOpen(false); // Close the modal
    setMiscData(""); // Reset the travel experience
  };

  // Column definitions for the table
  const columns = React.useMemo(
    () => [
      // {
      //   accessorKey: "id",
      //   header: "ID",
      //   enableColumnFilter: false, // Disable filter for this column
      // },
      {
        accessorKey: "invoice_number",
        header: "Invoice Number",
        enableColumnFilter: false, // Disable filter for this column
      },
      {
        accessorKey: "fromAirport",
        header: "Travel From",
        enableColumnFilter: false,
        Cell: ({ cell }) => cell?.getValue()?.name || "N/A",
      },
      {
        accessorKey: "toAirport",
        header: "Travel To",
        enableColumnFilter: false,
        Cell: ({ cell }) => cell?.getValue()?.name || "N/A",
      },

      {
        accessorKey: "airticket.airline_name",
        header: "Airline Name",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <p>
            {row.original?.airLine?.airline_name
              ? row.original?.airLine?.airline_name
              : "Empty"}
          </p>
        ),
      },
      {
        accessorKey: "customer_details.full_name",
        header: "Full Name",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => <p>{row.original?.customer_details?.full_name}</p>,
      },
      {
        accessorKey: "airticket",
        header: "Air Ticket",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.airticket_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original?.airticket,
                    invoice_main_id: row.original?.id,
                    booking_date: row.original?.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original?.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original?.valid_canadian_passport,
                    valid_travel_visa: row.original?.valid_travel_visa,
                    tourist_card: row.original?.tourist_card,
                    departure_date: row.original?.departure_date,
                    gds_locator: row.original?.gds_locator,
                    gds_type: row.original?.gds_type,
                    sales_agents: row.original?.sales_agents,
                    special_remarks: row.original?.special_remarks,
                    fromAirport: row.original?.fromAirport,
                    toAirport: row.original?.toAirport,
                    other_remarks: row.original?.other_remarks,
                    ticket_number: row.original?.ticket_number,
                    invoice_number: row.original?.invoice_number,
                    customer_details: row.original?.customer_details,
                    itinerary: row.original?.itinerary,
                    created_at: row.original?.created_at,
                    supplier: row.original?.supplier,
                    airLine: row.original?.airLine,
                    mco: row.original?.mco,
                    ref_no_et: row.original?.reference_no_et,
                    status: row.original?.status,
                  };
                  handleInvocieModalOpen(data);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "insurance",
        header: "Insurance",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.insurance_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.insurance,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    fromAirport: row.original?.fromAirport,
                    toAirport: row.original?.toAirport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                    airLine: row.original?.airLine,
                    supplier: row.original?.supplier,
                    gds_locator: row.original?.gds_locator,
                    mco: row.original?.mco,
                    ref_no_et: row.original?.reference_no_et,
                    status: row.original?.status,
                  };
                  setInsourenceData(data);
                  setIsInsourenceModalOpen(true);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "land_package",
        header: "Land Package",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.land_package_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.land_package,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    fromAirport: row.original?.fromAirport,
                    toAirport: row.original?.toAirport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                    airLine: row.original?.airLine,
                    supplier: row.original?.supplier,
                    gds_locator: row.original?.gds_locator,
                    mco: row.original?.mco,
                    ref_no_et: row.original?.reference_no_et,
                    status: row.original?.status,
                  };
                  setLandPackageData(data);
                  setIsLandPackageModalOpen(true);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "cruise",
        header: "Cruise",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.cruise_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.cruise,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    fromAirport: row.original?.fromAirport,
                    toAirport: row.original?.toAirport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                    airLine: row.original?.airLine,
                    supplier: row.original?.supplier,
                    gds_locator: row.original?.gds_locator,
                    mco: row.original?.mco,
                    ref_no_et: row.original?.reference_no_et,
                    status: row.original?.status,
                  };
                  setCruiseData(data);
                  setIsCruiseModalOpen(true);
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "hotel",
        header: "Hotel",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.hotel_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.hotel,
                    booking_date: row.original.booking_date,
                    canadian_citizenship_or_prCard:
                      row.original.canadian_citizenship_or_prCard,
                    valid_canadian_passport:
                      row.original.valid_canadian_passport,
                    fromAirport: row.original?.fromAirport,
                    toAirport: row.original?.toAirport,
                    valid_travel_visa: row.original.valid_travel_visa,
                    tourist_card: row.original.tourist_card,
                    departure_date: row.original.departure_date,
                    sales_agents: row.original.sales_agents,
                    special_remarks: row.original.special_remarks,
                    other_remarks: row.original.other_remarks,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                    airLine: row.original?.airLine,
                    supplier: row.original?.supplier,
                    gds_locator: row.original?.gds_locator,
                    mco: row.original?.mco,
                    ref_no_et: row.original?.reference_no_et,
                    status: row.original?.status,
                  };
                  setHotelData(data); // Set the travel experience text
                  setIsHotelModalOpen(true); // Open the modal
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "misc",
        header: "Misc",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <div>
            {row.original.misc_include === "true" ? (
              <button
                className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
                onClick={() => {
                  const data = {
                    ...row.original.misc,
                    sales_agents: row.original.sales_agents,
                    invoice_number: row.original.invoice_number,
                    customer_details: row.original.customer_details,
                    created_at: row.original.created_at,
                  };
                  setMiscData(data); // Set the travel experience text
                  setIsMiscModalOpen(true); // Open the modal
                }}
              >
                Open
              </button>
            ) : (
              <p>empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "customer_details",
        header: "Customer Details",
        enableColumnFilter: false, // Disable filter for this column
        Cell: ({ row }) => (
          <button
            className="btn btn-sm border border-purple-500 bg-purple-500 text-white outline-none hover:bg-white hover:text-purple-500"
            onClick={() =>
              handleCustomerModalOpen(row.original.customer_details)
            }
          >
            Open
          </button>
        ),
      },
      {
        accessorKey: "itinerary",
        header: "Itinerary",
        Cell: ({ row }) => (
          <div>
            {row.original.itinerary ? (
              <button
                className="btn btn-sm border border-orange-500 bg-orange-500 text-white outline-none hover:bg-white hover:text-orange-500"
                onClick={() => handleModalOpen(row.original.itinerary)}
              >
                Open
              </button>
            ) : (
              <p>Empty</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "created_at", // Adjust this to match your actual data structure
        header: "Created Date",
        filterVariant: "select",
        enableColumnFilter: false, // Enable filter for this column

        Cell: ({ cell }) => {
          const createdAt = new Date(cell.getValue());
          const date = createdAt.toLocaleDateString(); // Get the date portion
          const time = createdAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "updated_at", // Adjust this to match your actual data structure
        header: "Updated Date",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ cell }) => {
          const updatedAt = new Date(cell.getValue());
          const date = updatedAt.toLocaleDateString(); // Get the date portion
          const time = updatedAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "sales_agents",
        header: "Sales Agent",
        Cell: ({ cell }) => {
          const assignedBy = cell.getValue();

          return (
            <div className="flex items-center gap-2">
              <div className="tooltip" data-tip="Profile">
                <img
                  onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function
                  className="h-10 w-10 cursor-pointer rounded-full"
                  src={assignedBy?.full_path}
                  alt={assignedBy?.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avtar; // Default avatar
                  }}
                />
              </div>
              <div>
                <p>{assignedBy?.name}</p>
                <p>{assignedBy?.phone_no}</p>
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "createdByUser",
        header: "Created By",
        Cell: ({ cell }) => {
          const createdByUser = cell.getValue();

          return (
            <div className="flex items-center gap-2">
              <div className="tooltip" data-tip="Profile">
                <img
                  onClick={() => handleOpenModal(createdByUser)} // Wrap in an arrow function
                  className="h-10 w-10 cursor-pointer rounded-full"
                  src={createdByUser?.full_path}
                  alt={createdByUser?.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = avtar; // Default avatar
                  }}
                />
              </div>
              <div>
                <p>{createdByUser?.name}</p>
                <p>{createdByUser?.phone_no}</p>
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "updatedByUser",
        header: "Updated By",
        Cell: ({ cell }) => {
          const updatedByUser = cell.getValue();

          return (
            <div>
              {updatedByUser ? (
                <div className="flex items-center gap-2">
                  <div className="tooltip" data-tip="Profile">
                    <img
                      onClick={() => handleOpenModal(updatedByUser)} // Wrap in an arrow function
                      className="h-10 w-10 cursor-pointer rounded-full"
                      src={updatedByUser?.full_path}
                      alt={updatedByUser?.name}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = avtar; // Default avatar
                      }}
                    />
                  </div>
                  <div>
                    <p>{updatedByUser?.name}</p>
                    <p>{updatedByUser?.phone_no}</p>
                  </div>
                </div>
              ) : (
                <div>Not updated yet</div>
              )}
            </div>
          );
        },
      },
      // {
      //   accessorKey: "updatedByUser",
      //   header: "updated By",
      //   enableColumnFilter: true, // Enable filter for this column
      //   Filter: ({ column }) => (
      //     <SelectFilter
      //       options={createdByData}
      //       selectedId={updatedById}
      //       setSelectedId={setUpdatedById}
      //       column={column}
      //       placeholder="Updated By..."
      //     />
      //   ),
      //   Cell: ({ cell }) => {
      //     const assignedBy = cell.getValue();
      //     return (
      //       <div className="flex items-center gap-2">
      //         {assignedBy ? (
      //           <>
      //             <div className="tooltip" data-tip="Profile">
      //               <img
      //                 onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function for passing data
      //                 className="h-10 w-10 cursor-pointer rounded-full"
      //                 src={assignedBy?.full_path}
      //                 alt={assignedBy?.name || "User Avatar"}
      //                 onError={(e) => {
      //                   e.target.onerror = null;
      //                   e.target.src = avtar; // Default avatar
      //                 }}
      //               />
      //             </div>
      //             <div>
      //               <p>{assignedBy?.name}</p>
      //               <p>{assignedBy?.phone_no}</p>
      //             </div>
      //           </>
      //         ) : (
      //           "N/A"
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        accessorKey: "history",
        header: "History",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ row }) => (
          <div
            className="flex space-x-1"
            onClick={() =>
              navigate("/admin/invoice-history", {
                state: row?.original?.children,
              })
            }
          >
            <SubmitButton
              add="History"
              extraClass={"bg-purple-500 hover:bg-purple-700 rounded-lg"}
            />
          </div>
        ),
      },
      {
        accessorKey: "action",
        header: "Action",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ row }) => (
          <div className="flex items-center space-x-2">
            <Edit
              className="cursor-pointer text-blue-500"
              onClick={() => {
                if (row.original.airticket_include === "true") {
                  navigate(`/admin/create-new-invoice/air-ticket`, {
                    state: {
                      data: row.original,
                    },
                  });
                } else if (row.original.insurance_include === "true") {
                  navigate(`/admin/create-new-invoice/insurance`, {
                    state: {
                      data: row.original,
                    },
                  });
                } else if (row.original.hotel_include === "true") {
                  navigate(`/admin/create-new-invoice/hotel`, {
                    state: {
                      data: row.original,
                    },
                  });
                } else if (row.original.land_package_include === "true") {
                  navigate(`/admin/create-new-invoice/land-package`, {
                    state: {
                      data: row.original,
                    },
                  });
                } else if (row.original.cruise_include === "true") {
                  navigate(`/admin/create-new-invoice/cruise`, {
                    state: {
                      data: row.original,
                    },
                  });
                } else if (row.original.misc_include === "true") {
                  navigate(`/admin/create-new-invoice/misc`, {
                    state: {
                      data: row.original,
                    },
                  });
                }
              }}
            />

            {userInfo?.data?.role_id ===
              Number(process.env.REACT_APP_ROLE_SUPERADMIN) ||
            userInfo?.data?.role_id ===
              Number(process.env.REACT_APP_ROLE_ADMIN) ? (
              <ConfirmModal
                onConfirm={handleDelete}
                title="Delete invoice"
                message="Are you sure you want to delete this invoice?"
                employeeId={row.original.id}
              />
            ) : null}
          </div>
        ),
      },
    ],
    [data]
  );

  const handleDelete = async (id) => {
    // Show loading toast
    const loadingToastId = toast.loading("Deleting invoice...");

    try {
      await userResources.deleteInvoice(id); // Attempt to delete the airline

      // Update toast to show success
      toast.update(loadingToastId, {
        render: "invoice deleted successfully.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });

      // Refresh the invoice list
      getInvoiceList(
        pagination.pageIndex,
        pagination.pageSize,
        globalFilter,
        filter
      );
    } catch (error) {
      console.error("Error deleting invoice:", error);

      // Update toast to show error
      const errorMessage =
        error.response?.data?.message ||
        "Failed to delete invoice. Please try again.";
      toast.update(loadingToastId, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      // Dismiss the loading toast if not already dismissed
      if (toast.isActive(loadingToastId)) {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const sendEmailToAll = () => {
    const emails = data.map((item) => item?.customer_details?.email).join(",");
    const subject = "Hello Everyone!";
    const body = "Hi Team,\n\n";
    const mailtoLink = `mailto:${emails}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink);
  };

  // pagination
  const handleGlobalFilterChange = (value) => {
    setGlobalFilter(value); // Update the global filter state with the new value
  };
  const handlePaginationChange = (updatedPagination) => {
    setPagination(updatedPagination);
  };

  // console.log(columnsFilterValue, "columnsFilterValue");

  useEffect(() => {
    getInvoiceList(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      filter
    );
  }, [pagination, startDate, endDate, globalFilter]);

  useEffect(() => {
    getInvoiceList(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      filter
    );
  }, []);

  // generateExcelFIle

  return (
    <section className="mx-2 mt-0 sm:mt-5">
      <ScrollToTopOnRouteChange />
      <div
        className={`"sm:grid-cols-1 mb-4 grid grid-cols-1 items-center justify-between gap-4 md:grid-cols-2`}
      >
        {/* <button className="btn">{location?.state?.name} Enquirys</button> */}
        <div className="grid grid-cols-1 gap-4 rounded-[20px] bg-gray-300 p-2 dark:bg-white sm:grid-cols-2">
          <label
            className={`flex items-end justify-between gap-5 whitespace-nowrap text-sm font-medium text-gray-900 ${
              location?.state?.name ? "sm:flex-col sm:gap-0" : ""
            } sm:items-start `}
          >
            Start Date:{" "}
            <DateFilter
              selectedDate={startDate}
              setSelectedDate={setStartDate}
            />
          </label>
          <label
            className={`flex items-end justify-between gap-5 whitespace-nowrap text-sm font-medium text-gray-900 ${
              location?.state?.name ? "sm:flex-col sm:gap-0" : ""
            } sm:items-start `}
          >
            End Date:{" "}
            <DateFilter
              selectedDate={endDate}
              setSelectedDate={setEndDate}
              minDate={startDate} // Pass Start Date as the minimum date for End Date
            />
          </label>
        </div>
        <SubmitButton
          onClick={sendEmailToAll}
          add="Send Email to All"
          extraClass={
            "h-full bg-green-500 hover:bg-green-700 rounded-[20px] mt-2 sm:mt-0"
          }
        />
      </div>

      {/* Modal for User Info */}
      <div className="">
        {isModalOpen && (
          <UserInfoModal user={userProfile} onClose={handleCloseModal} />
        )}
      </div>

      <MaterialReactTable
        columns={columns}
        data={data}
        renderTopToolbarCustomActions={() => (
          <button
            className={`flex items-center gap-2 rounded-md border border-green-600 px-4 py-2 text-green-700 transition-all duration-200
    hover:bg-green-600 hover:text-white 
    ${isLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
            onClick={() => !isLoading && generateExcelFile(data)}
            disabled={isLoading}
          >
            <FaFileExcel size={18} />
            Export to Excel
          </button>
        )}
        actions={[
          {
            icon: () => (
              <button
                onClick={() => alert("Button clicked!")}
                className="ml-2 rounded bg-blue-500 px-4 py-2 text-white"
              >
                Custom Button
              </button>
            ),
            isFreeAction: true,
          },
        ]}
        title="My Custom Table"
        state={{
          pagination,
          isLoading,
          showProgressBars: isLoading,
          showAlertBanner: isError,
          // columnFilters: columnsFilterValue,
        }} // Use both states here
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Error loading data",
              }
            : undefined
        }
        enableColumnFilters={false}
        initialState={{
          showColumnFilters: false,
        }}
        enableSorting={false}
        enableColumnOrdering={false}
        enableRowActions
        enablePagination
        onPaginationChange={handlePaginationChange}
        manualPagination
        rowCount={totalRows}
        pageCount={Math.ceil(totalRows / pagination.pageSize)}
        isLoading={isLoading}
        muiTablePaginationProps={{
          showFirstButton: true,
          showLastButton: true,
        }}
        enableGlobalFilter // Keep this true to allow global filtering
        onGlobalFilterChange={handleGlobalFilterChange} // Update the state on filter change
        globalFilter={globalFilter} // Pass the state variable to the table
        renderRowActions={({ row }) => (
          <div className="flex flex-nowrap gap-4">
            <button
              className="text-xl text-primary"
              onClick={() =>
                window.open(
                  `mailto:${row.original?.customer_details?.email}?subject=Hello ${row.original?.customer_details?.full_name}!`
                )
              }
            >
              <FaMailBulk />
            </button>
            <button
              className="text-xl text-success"
              onClick={() =>
                window.open(
                  `https://wa.me/${row.original?.customer_details?.phone_number.replace(
                    /\D/g,
                    ""
                  )}?text=Hello ${row.original?.customer_details?.full_name}!`
                )
              }
            >
              <FaWhatsapp />
            </button>
          </div>
        )}
      />
      {/* DaisyUI Modal */}
      {isInfoModalOpen && (
        <Modal
          heading="Itinerary"
          paragraph={itinerary}
          close={handleModalClose}
        />
      )}

      {/* customer Data modal */}
      {isCustomerModalOpen && (
        <CustomerInfoModal
          data={customerModalData}
          close={handleCustomerModalClose}
        />
      )}

      {/* Invoice Data modal */}
      {isInvoiceModalOpen && (
        <AirticketInvoiceModal
          data={invocieData}
          close={handleInvoiceModalClose}
        />
      )}

      {/* Invoice Data modal */}
      {isInsourenceModalOpen && (
        <InvoiceModal
          data={insourenceData}
          close={handleInsouranceModalClose}
        />
      )}

      {isHotelModalOpen && (
        <InvoiceModal
          data={hotelData}
          close={handleHotelModalClose}
          hotel={true}
        />
      )}

      {isLandPackageModalOpen && (
        <InvoiceModal
          data={landPackageData}
          close={handleLandPackageModalClose}
          landPackage={true}
        />
      )}

      {isCruiseModalOpen && (
        <InvoiceModal
          data={cruiseData}
          close={handleCruiseModalClose}
          cruise={true}
        />
      )}
      {isMiscModalOpen && (
        <MiscInvoiceModal data={miscData} close={handleMiscModalClose} />
      )}
    </section>
  );
}
